
/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { Spinner, GeneralError } from 'components';
import { InvoiceService } from 'frilans-finans';
import CalculatorPostEntity from '../../../frilans-finans/calculator/calculator-post-entity';
import CalculatorWorkerEntity from '../../../frilans-finans/calculator/calculator-worker-entity';

export class Calculator extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    taxkeys: PropTypes.array.isRequired
  };

  static contextTypes = {
    user: PropTypes.object.isRequired,
    taxkeys: PropTypes.array.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      showAdvanced: false,
      showTables: false,
      valuesSet: false,
      posting: false,
      postError: false,
      calculation: null,
      input: {
        type: 'amount',
        value: '0'
      },
      worker: this.createCalculatorCoworkerEntity(props)
    };

    this.toggleAdvanced = this.toggleAdvanced.bind(this);
    this.toggleTables = this.toggleTables.bind(this);
    this.updateTravelOrAllowance = this.updateTravelOrAllowance.bind(this);
    this.updateMainValues = this.updateMainValues.bind(this);
    this.checkboxClick = this.checkboxClick.bind(this);
    this.switchValues = this.switchValues.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    this.setState(Object.assign(this.state, {
      worker: this.createCalculatorCoworkerEntity(nextProps)
    }));
  }

  createCalculatorCoworkerEntity (props) {
    let taxKey = this.getTaxKey(props.user.defaultTaxkeyId, props.taxkeys);

    let calculatorCoworkerEntity = new CalculatorWorkerEntity();
    calculatorCoworkerEntity.fee = 6;
    calculatorCoworkerEntity.tax = taxKey.taxAmount || 0;
    calculatorCoworkerEntity.vat = 25;
    calculatorCoworkerEntity.payroll_tax = taxKey.payrollTax || 0;
    calculatorCoworkerEntity.vacation = props.user.saveVacationPay || false;
    calculatorCoworkerEntity.itp = props.user.socialSecurityNr != null
      ? props.user.saveITP
      : true;
    calculatorCoworkerEntity.travel = 0;
    calculatorCoworkerEntity.allowance = 0;
    calculatorCoworkerEntity.id = props.user.id;

    return calculatorCoworkerEntity;
  }

  getTaxKey (taxkeyId, taxkeys) {
    for (let i = 0; i < taxkeys.length; i++) {
      if (parseInt(taxkeyId) === parseInt(taxkeys[i].id)) {
        return taxkeys[i];
      }
    }

    return {};
  }

  toggleAdvanced () {
    this.setState({
      showAdvanced: !this.state.showAdvanced
    });
  }

  toggleTables () {
    this.setState({
      showTables: !this.state.showTables
    });
  }

  /**
   * Switch the values between Invoice and Salary
   *
   * Currently unused
   */
  switchValues () {
    let type;

    if (this.state.input.type === 'amount') {
      type = 'salary';
      this.refs.salary.value = this.refs.amount.value;
      this.refs.amount.value = '';
    } else {
      type = 'amount';
      this.refs.amount.value = this.refs.salary.value;
      this.refs.salary.value = '';
    }

    this.setState({
      input: {
        type: type,
        value: this.state.input.value
      }
    }, this.startRequestTimeout);
  }

  /**
   * Required function when you have the checked attribute on a checkbox
   */
  onChange (e) {}

  /**
   * Handle Vacation and Allowance fields
   */
  updateTravelOrAllowance (e) {
    // Force a positive value
    if (e.target.value) {
      e.target.value = Math.abs(e.target.value);
    }
    let worker = this.state.worker;
    worker[e.target.name] = e.target.value ? parseInt(e.target.value) : 0;

    this.setState({worker: worker}, this.startRequestTimeout);
  }

  /**
   * Handle ITP and Vacation booleans
   */
  checkboxClick (e) {
    let worker = this.state.worker;
    worker[e.target.name] = e.target.checked;

    this.setState({worker: worker}, this.startRequestTimeout);
  }

  /**
   * Handle values from Invoice and Salary fields
   */
  updateMainValues (e) {
    this.setState({
      input: {
        value: e.target.value ? parseInt(e.target.value) : 0,
        type: e.target.name
      }
    }, this.startRequestTimeout);
  }

  /**
   * Wait 300 ms since last input before making the request to
   * the backend.
   */
  startRequestTimeout () {
    if (this.requestTimeout) {
      window.clearTimeout(this.requestTimeout);
    }

    this.requestTimeout = setTimeout(this.makeRequest.bind(this), 300);
  }

  makeRequest () {
    if (this.state.input.value && this.state.input.value > 0) {
      let worker = Object.assign({}, this.state.worker);

      let calculatorPostEntity = new CalculatorPostEntity();
      calculatorPostEntity.vat = 25;

      if (this.state.input.type === 'amount') {
        calculatorPostEntity.amount = this.state.input.value;
      } else {
        worker.net = this.state.input.value;
      }

      calculatorPostEntity.workers = [worker];

      this.setState({
        posting: true,
        postError: false
      }, () => {
        InvoiceService.getInvoiceCalculation(calculatorPostEntity)
          .then(this.handleResponse.bind(this))
          .catch(this.handleError.bind(this));
      });
    }
  }

  handleResponse (response) {
    response = response.invoiceCalculations[0];
    this.setState({
      posting: false,
      postError: false,
      calculation: response
    }, () => {
      if (this.state.input.type === 'amount') {
        this.refs.salary.value = Math.round(response.net);
      } else {
        this.refs.amount.value = Math.round(response.amount);
      }
    });
  }

  handleError () {
    this.setState({
      posting: false,
      postError: true
    });
  }

  renderError () {
    if (this.state.postError) {
      return (<GeneralError/>);
    }
  }

  renderVacationPay () {
    if (this.state.worker.vacation) {
      return (
        <tr>
          <td><Translate content='VACATION_PAY'/></td>
          <td>{Math.round(this.state.calculation.vacationGross)} kr</td>
        </tr>
      );
    }
  }

  renderITP () {
    if (this.state.worker.itp) {
      return (
        <tr>
          <td><Translate content='ITP'/></td>
          <td>{Math.round(this.state.calculation.itp)} kr</td>
        </tr>
      );
    }
  }

  renderITPCheckbox () {
    if (this.props.user.canChangeItp && this.props.user.socialSecurityNr != null) {
      return (
        <div className='first-col'>
          <input id='itp' type='checkbox' name='itp' onChange={this.onChange}
            checked={this.state.worker.itp} onClick={this.checkboxClick} />
          <label htmlFor='itp' className='small-label'>
            <span></span><Translate content='SAVE_PENSION'/>
          </label>
        </div>
      );
    }
  }

  renderAdvancedCalculations () {
    if (this.state.showAdvanced) {
      return (
        <div>
          <div className='flex-form'>
            <div className='first-col'>
              <div className='flex-form check-boxes break-1200'>
                {this.renderITPCheckbox()}
                <div className='last-col'>
                  <input id='vacation' type='checkbox' name='vacation' onChange={this.onChange}
                    checked={this.state.worker.vacation} onClick={this.checkboxClick} />
                  <label htmlFor='vacation' className='small-label'>
                    <span></span><Translate content='SAVE_VACATION'/>
                  </label>
                </div>
              </div>
            </div>

            <div className='last-col'>
              <div className='flex-form break-1200'>
                <div className='first-col'>
                  <input type='number' name='travel'
                    placeholder={proxyCounterpart('TRAVEL_FEE_SEK')} onChange={this.updateTravelOrAllowance} />
                </div>
                <div className='last-col'>
                  <input type='number' name='allowance'
                    placeholder={proxyCounterpart('TRAVEL_ALLOWANCE_SEK')}
                    onChange={this.updateTravelOrAllowance} />
                </div>
              </div>
            </div>

          </div>

          <button className='btn-minus' onClick={this.toggleAdvanced}><Translate content='HIDE_ADV_CALC'/></button>
        </div>
      );
    }

    return (
      <button className='btn-plus' onClick={this.toggleAdvanced}><Translate content='ADV_CALC'/></button>
    );
  }

  renderTables () {
    if (this.state.calculation) {
      if (this.state.showTables) {
        let c = this.state.calculation;
        return (
          <div>
            <div className='flex-form tables-wrapper'>
              <div className='first-col'>
                <table className='clean-table'>
                  <tbody>
                    <tr>
                      <td><Translate content='INVOICE_INC_VAT'/></td>
                      <td>{Math.round(c.amount + c.vat)} kr</td>
                    </tr>
                    <tr>
                      <td><Translate content='VAT'/></td>
                      <td>{Math.round(c.vat)} kr</td>
                    </tr>
                    <tr>
                      <td><Translate content='INVOICE_AMOUNT'/></td>
                      <td>{Math.round(c.amount)} kr</td>
                    </tr>
                    <tr>
                      <td><Translate content='FRILANS_FINANS'/></td>
                      <td>{Math.round(c.fee)} kr</td>
                    </tr>
                    {this.renderITP()}
                  </tbody>
                </table>
              </div>

              <div className='last-col'>
                <table className='clean-table'>
                  <tbody>
                    <tr>
                      <td><Translate content='SOCIAL_FEES'/></td>
                      <td>{Math.round(c.totalPayrollTax)} kr</td>
                    </tr>
                    <tr>
                      <td>
                        <Translate
                          content={this.state.worker.vacation ? 'GROSS_EXCL_VACATION' : 'GROSS_SALARY_VACATION'}
                        />
                      </td>
                      <td>{Math.round(c.gross)} kr</td>
                    </tr>
                    <tr>
                      <td><Translate content='TAX'/></td>
                      <td>{Math.round(c.tax)} kr</td>
                    </tr>
                    {this.renderVacationPay()}
                    {this.renderNet()}
                    {this.renderPaidToClient()}
                  </tbody>
                </table>
              </div>
            </div>
            <button className='btn-minus' onClick={this.toggleTables}><Translate content='HIDE_HOW_CALC'/></button>
          </div>
        );
      }

      return (
        <button className='btn-plus' onClick={this.toggleTables}><Translate content='HOW_CALC'/></button>
      );
    }
  }

  renderNet () {
    let c = this.state.calculation;

    const hasExpense = c.travel > 0 || c.allowance > 0;
    const netTextClass = !hasExpense ? 'blue-fat' : '';

    return (
      <tr>
        <td className={netTextClass}>
          <Translate content={this.state.worker.vacation ? 'NET_EXCL_VACATION' : 'NET_SALARY_VACATION'}/>
        </td>
        <td className={netTextClass}>{Math.round(c.net)} kr</td>
      </tr>
    );
  }

  renderPaidToClient () {
    let c = this.state.calculation;

    const hasExpense = c.travel > 0 || c.allowance > 0;

    if (hasExpense) {
      return (
        <tr>
          <td className='blue-fat'>
            <Translate content={'TOTAL_PAID_TO_CLIENT'}/>
          </td>
          <td className='blue-fat'>{Math.round(c.toPay)} kr</td>
        </tr>
      );
    }
  }

  renderSpinner () {
    if (this.state.posting) {
      return (<Spinner size={25} />);
    }

    // Render switch button if we want to add it again
    // return (<button className='switch-btn' onClick={this.switchValues}></button>);
  }

  renderForm () {
    return (
      <div className='calc-form'>
        <div className='flex-form'>
          <div className='invoice-amount first-col'>
            <label htmlFor='amount' className='blue-label'><Translate content='AMOUNT_INVOICE' /></label>
            <input
              ref='amount'
              type='number'
              name='amount'
              placeholder={proxyCounterpart('AMOUNT_INVOICE_PLACEHOLDER')}
              onChange={this.updateMainValues}
            />
          </div>
          <div className="spinner-wrapper">
            {this.renderSpinner()}
          </div>
          <div className='salary-amount last-col'>
            <label htmlFor='salary' className='blue-label'><Translate content='SALARY_AFTER_TAX' /></label>
            <input
              ref='salary'
              type='number'
              name='salary'
              placeholder={proxyCounterpart('SALARY_AFTER_TAX')}
              onChange={this.updateMainValues}
            />
          </div>
        </div>

        {this.renderAdvancedCalculations()}
        {this.renderTables()}
        {this.renderError()}

      </div>
    );
  }

  render () {
    return (
      <div id='calculator' className='calculator'>
        <div id='calculator-anchor'></div>
        <div className='calculator-header'>
          <div className='icon-heading'>
            <h2><Translate content='CALCULATOR' /></h2>
            <p><Translate content='CALCULATOR_TEXT' /></p>
          </div>
        </div>
        {this.renderForm()}
      </div>
    );
  }
}

export default Calculator;



/** WEBPACK FOOTER **
 ** ./src/views/activities-view/calculator/calculator.js
 **/